import React, { useState } from 'react'
import { Typography, Card, Avatar, Button, Upload, Row, Col, message, Tooltip } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import axios from 'axios'
import { Head, Loaded, Approved, Rejected } from './styles'
import _ from 'lodash'
import { beforeUpload, compressFile, getBase64 } from '../../utils/services'
const { Title } = Typography;

const ValidateBrand = (props) => {
  const { me } = props
  const { Meta } = Card;
  const dispatch = useDispatch()
  const [fileCer, setFileCer] = useState(null)
  const [fileVat, setFileVat] = useState(null)
  const [doc, setdoc] = useState({})
  const [imageCerUrl, setImageCerUrl] = useState('')
  const [imageVatUrl, setImageVatUrl] = useState('')

  async function fetchDetailBrandDoc() {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/document/detailBrandDoc/` + `${me.id}`
      )
      setdoc(res.data)
    } catch (err) {
      console.log(err)
    }
  }
  useDeepEffect(() => {
    fetchDetailBrandDoc()

    return () => {
      setImageCerUrl('')
      setFileCer(null)
      setImageVatUrl('')
      setFileVat(null)
    }
  }, [])

  console.log(me)


  const handleChangeCer = (info) => {
    getBase64(info.file, (imageUrl) => setImageCerUrl(info.file.name))
  }

  const handleChangeVat = (info) => {
    getBase64(info.file, (imageUrl) => setImageVatUrl(info.file.name))
  }

  async function createBrandDoc(data) {
    const token = localStorage.getItem('user-token')
    const authorizationHeader = token ? token : ''
    const brandId = data.brandId
    const docId = data.docId
    const imageUrl = data.imageUrl
    try {
      await axios.post(
        process.env.REACT_APP_API_ENDPOINT + `/document/brandUserCreateDocument`, null, {
        headers: {
          Authorization: authorizationHeader
        },
        params: {
          brandId: brandId,
          docId: docId,
          imageUrl: imageUrl
        }
      })
    } catch (err) {
      console.log(err)
    }
  }


  async function updateBrandDoc(data) {
    const token = localStorage.getItem('user-token')
    const authorizationHeader = token ? token : ''
    const brandId = data.brandId
    const docId = data.docId
    const imageUrl = data.imageUrl
    try {
      await axios.put(
        process.env.REACT_APP_API_ENDPOINT + `/document/updateBrandUserDocument`, null, {
        headers: {
          Authorization: authorizationHeader
        },
        params: {
          brandId: brandId,
          docId: docId,
          imageUrl: imageUrl
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  const UploadCer = async (e) => {
    e.preventDefault()
    const data = {
      docId: 2,
      brandId : me.id
    }
    try {
      const formImgData = new FormData()
      if (!_.isNull(fileCer)) {
        formImgData.append('image', await compressFile(fileCer))
        const res = await axios.post(
          process.env.REACT_APP_API_ENDPOINT + `/document/image`,
          formImgData,
          {
            headers: {
              'content-type': 'multipart/form-data'
            }
          }
        )
        data.imageUrl = res.data.url
      }
    } catch (err) {
      console.log(err)
    }
    createBrandDoc(data)
    setImageCerUrl('')
    setFileCer(null)
    setImageVatUrl('')
    setFileVat(null)
    setFileVat(null)
    setTimeout(() => {
      fetchDetailBrandDoc()
      window.location.href = "/validate-brand";
    }, 1000)
    message.success('อัพโหลดไฟล์เรียบร้อย')
  }
  const UploadVat = async (e) => {
    e.preventDefault()
    const data = {
      docId: 5,
      brandId : me.id
    }
    try {
      const formImgData = new FormData()
      if (!_.isNull(fileVat)) {
        formImgData.append('image', await compressFile(fileVat))
        const res = await axios.post(
          process.env.REACT_APP_API_ENDPOINT + `/document/image`,
          formImgData,
          {
            headers: {
              'content-type': 'multipart/form-data'
            }
          }
        )
        data.imageUrl = res.data.url
      }
    } catch (err) {
      console.log(err)
    }
    createBrandDoc(data)
    setImageCerUrl('')
    setFileCer(null)
    setImageVatUrl('')
    setFileVat(null)
    setTimeout(() => {
      fetchDetailBrandDoc()
      window.location.href = "/validate-brand";
    }, 1000)
    message.success('อัพโหลดไฟล์เรียบร้อย')
  }
  const UpdateCer = async (e) => {
    e.preventDefault()
    const data = {
      docId: 2,
      brandId : me.id
    }
    try {
      const formImgData = new FormData()
      if (!_.isNull(fileCer)) {
        formImgData.append('image', await compressFile(fileCer))
        const res = await axios.post(
          process.env.REACT_APP_API_ENDPOINT + `/document/image`,
          formImgData,
          {
            headers: {
              'content-type': 'multipart/form-data'
            }
          }
        )
        data.imageUrl = res.data.url
      }
    } catch (err) {
      console.log(err)
    }
    updateBrandDoc(data)
    setImageCerUrl('')
    setFileCer(null)
    setImageVatUrl('')
    setFileVat(null)
    setFileVat(null)
    setTimeout(() => {
      fetchDetailBrandDoc()
      window.location.href = "/validate-brand";
    }, 1000)
    message.success('อัพเดทไฟล์เรียบร้อย')
  }
  const UpdateVat = async (e) => {
    e.preventDefault()
    const data = {
      docId: 5,
      brandId : me.id
    }
    try {
      const formImgData = new FormData()
      if (!_.isNull(fileVat)) {
        formImgData.append('image', await compressFile(fileVat))
        const res = await axios.post(
          process.env.REACT_APP_API_ENDPOINT + `/document/image`,
          formImgData,
          {
            headers: {
              'content-type': 'multipart/form-data'
            }
          }
        )
        data.imageUrl = res.data.url
      }
    } catch (err) {
      console.log(err)
    }
    updateBrandDoc(data)
    setImageCerUrl('')
    setFileCer(null)
    setImageVatUrl('')
    setFileVat(null)
    setTimeout(() => {
      fetchDetailBrandDoc()
      window.location.href = "/validate-brand";
    }, 1000)
    message.success('อัพเดทไฟล์เรียบร้อย')
  }

  return (
    <Card title={<Title level={4}>อัพโหลดเอกสารเพื่อยืนยันตันตน</Title>}
      headStyle={{ textSizeAdjust: '100', textAlign: 'center' }} bordered={true}>
      <Head>
        เราต้องการเอกสารของคุณเพื่อยืนยันการเป็นเจ้าของสินค้า โดยเอกสารของคุณจะไม่ถูกเผยแพร่หรือแสดงบน Green2Get
      </Head>
      <Card style={{ marginTop: 16 }} type="inner" extra={
        <div>
          {doc[0] && doc[0].status == "PENDING" ? (
            <Loaded>
              อัพโหลดแล้ว
            </Loaded>
          ) : (doc[0] && doc[0].status == "APPROVED" ? (
            <Approved>
              ตรวจสอบแล้ว
            </Approved>
          ) : (doc[0] && doc[0].status == "REJECT" ? (
            <div>
              {imageCerUrl ? (
                <div
                  style={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <Row gutter={16} type="flex" justify="center" align="middle">
                    <Col span={10} >
                      <Button
                        type="primary"
                        size="small"
                        onClick={(e) => {
                          UpdateCer(e)
                        }}
                      >ยืนยัน
                      </Button>
                    </Col>
                    <Col span={7}>
                      <Upload
                        name="cer"
                        showUploadList={false}
                        onChange={handleChangeCer}
                        beforeUpload={(fileCer) => beforeUpload(fileCer, setFileCer)}>
                        <Button
                          size="small"
                          title="อัพโหลด"
                        >อัพโหลด</Button>
                      </Upload>
                    </Col>
                  </Row>
                </div>
              ) : (<div>
                <Rejected>
                  เอกสารถูกปฎิเสธ
                </Rejected>
                <Upload
                  name="cer"
                  showUploadList={false}
                  onChange={handleChangeCer}
                  beforeUpload={(fileCer) => beforeUpload(fileCer, setFileCer)}>
                  <Button
                    size="small"
                    title="อัพโหลด"
                  >อัพโหลดใหม่</Button>
                </Upload>
              </div>
              )}
            </div>
          ) : (
            <div>
              {imageCerUrl ? (
                <div
                  style={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <Row gutter={16} type="flex" justify="center" align="middle">
                    <Col span={10} >
                      <Button
                        type="primary"
                        size="small"
                        onClick={(e) => {
                          UploadCer(e)
                        }}
                      >ยืนยัน
                      </Button>
                    </Col>
                    <Col span={7}>
                      <Upload
                        name="cer"
                        showUploadList={false}
                        onChange={handleChangeCer}
                        beforeUpload={(fileCer) => beforeUpload(fileCer, setFileCer)}>
                        <Button
                          size="small"
                          title="อัพโหลด"
                        >อัพโหลด</Button>
                      </Upload>
                    </Col>
                  </Row>
                </div>
              ) : (
                <Upload
                  name="cer"
                  showUploadList={false}
                  onChange={handleChangeCer}
                  beforeUpload={(fileCer) => beforeUpload(fileCer, setFileCer)}>
                  <Button
                    size="small"
                    title="อัพโหลด"
                  >อัพโหลด</Button>
                </Upload>
              )}
            </div>)))}
        </div>
      }>
        <Meta
          avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />}
          title="หนังสือรับรอง (Certificate)"
          description="This is the description"
        />
      </Card>
      <Card style={{ marginTop: 16 }} type="inner" extra={
        <div>
          {doc[1] && doc[1].status == "PENDING" ? (
            <Loaded>
              อัพโหลดแล้ว
            </Loaded>
          ) : (doc[1] && doc[1].status == "APPROVED" ? (
            <Approved>
              ตรวจสอบแล้ว
            </Approved>
          ) : (doc[1] && doc[1].status == "REJECT" ? (
            <div>
              {imageVatUrl ? (
                <div
                  style={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <Row gutter={16} type="flex" justify="center" align="middle">
                    <Col span={10} >
                      <Button
                        type="primary"
                        size="small"
                        onClick={(e) => {
                          UpdateVat(e)
                        }}
                      >ยืนยัน</Button>
                    </Col>
                    <Col span={7}>
                      <Upload
                        name="vat"
                        showUploadList={false}
                        onChange={handleChangeVat}
                        beforeUpload={(fileVat) => beforeUpload(fileVat, setFileVat)}>
                        <Button
                          size="small"
                          title="อัพโหลด"
                        >อัพโหลด
                        </Button>
                      </Upload>
                    </Col>
                  </Row>
                </div>
              ) : (
                <div>
                  <Rejected>
                    เอกสารถูกปฎิเสธ
                  </Rejected>
                  <Upload
                    name="vat"
                    showUploadList={false}
                    onChange={handleChangeVat}
                    beforeUpload={(fileVat) => beforeUpload(fileVat, setFileVat)}>
                    <Button
                      size="small"
                      title="อัพโหลด"
                    >อัพโหลดใหม่
                    </Button>
                  </Upload>
                </div>
              )}
            </div>
          ) : (
            <div>
              {imageVatUrl ? (
                <div
                  style={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <Row gutter={16} type="flex" justify="center" align="middle">
                    <Col span={10} >
                      <Button
                        type="primary"
                        size="small"
                        onClick={(e) => {
                          UploadVat(e)
                        }}
                      >ยืนยัน</Button>
                    </Col>
                    <Col span={7}>
                      <Upload
                        name="vat"
                        showUploadList={false}
                        onChange={handleChangeVat}
                        beforeUpload={(fileVat) => beforeUpload(fileVat, setFileVat)}>
                        <Button
                          size="small"
                          title="อัพโหลด"
                        >อัพโหลด
                        </Button>
                      </Upload>
                    </Col>
                  </Row>
                </div>
              ) : (
                <Upload
                  name="vat"
                  showUploadList={false}
                  onChange={handleChangeVat}
                  beforeUpload={(fileVat) => beforeUpload(fileVat, setFileVat)}>
                  <Button
                    size="small"
                    title="อัพโหลด"
                  >อัพโหลด
                  </Button>
                </Upload>
              )}
            </div>)))}
        </div>
      }>
        <Meta
          avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />}
          title="ใบทะเบียนภาษีมูลค่าเพิ่ม ภ.พ.20 (VAT Registration Certificate)"
          description="This is the description"
        />
      </Card>

    </Card>
  )
}

export default ValidateBrand



// WEBPACK FOOTER //
// ./src/pages/ValidateBrand/index.js